"use client";

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "@watt/ui/components/ui/accordion";
import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import type { PropsWithChildren } from "react";

type DevtoolsSectionProps = PropsWithChildren<{
  value: string;
  title: string;
  description: string;
  className?: string;
}>;

/**
 * A collapsible group inside the Local Devtools panel. Must be rendered
 * inside the panel's `Accordion`.
 */
export function DevtoolsSection({
  value,
  title,
  description,
  className,
  children
}: DevtoolsSectionProps) {
  return (
    <AccordionItem className="last:border-b-0" value={value}>
      <AccordionTrigger className="py-2 text-sm hover:no-underline">
        <span className="flex flex-col items-start gap-0.5 text-left">
          <span>{title}</span>
          <span className="font-normal text-muted-foreground text-xs">
            {description}
          </span>
        </span>
      </AccordionTrigger>
      <AccordionContent className={cn("pt-1 pb-3", className)}>
        {children}
      </AccordionContent>
    </AccordionItem>
  );
}
